export const BASE_URL: string = window.location.origin + "/";
export const GOOGLE_MAPS_API_KEY: string = "AIzaSyChOqRd16wByY7UNAwXUC53LMCzlMiIzdI";